import { render, staticRenderFns } from "./RichTextBubbleMenu.vue?vue&type=template&id=c73fea10&"
import script from "./RichTextBubbleMenu.vue?vue&type=script&lang=js&"
export * from "./RichTextBubbleMenu.vue?vue&type=script&lang=js&"
import style0 from "./RichTextBubbleMenu.vue?vue&type=style&index=0&id=c73fea10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports